import type { Web3Modal } from '@web3modal/wagmi/dist/types/src/client';
import { writable, type Writable } from 'svelte/store';

export const web3Modal: Writable<Web3Modal> = writable();
